module.exports = __webpack_public_path__ + "static/media/thor-vol1-the-goddess-of-thunder.da58d371.jpg";